const PLACEHOLDER_QR_REGEX = /^[0-9a-f]{64}$/i;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const SHORT_TICKET_CODE_REGEX = /^[A-HJ-NP-Z2-9]{8}$/;

// Indica se o valor de qr_code já é um código "pronto para exibir" (QR definitivo
// gerado), e não um placeholder/estado intermediário.
// - JWT assinado (3 partes separadas por ".") → ingresso legado pronto
// - Código curto de 8 chars → ingresso novo pronto
// - Placeholder hex (64) ou UUID cru (= ainda não gerado) ou vazio → não pronto
export function isValidQrCode(qrCode: string | null | undefined): boolean {
  const v = qrCode?.trim();
  if (!v) return false;
  if (PLACEHOLDER_QR_REGEX.test(v)) return false;
  if (UUID_REGEX.test(v)) return false;
  if (SHORT_TICKET_CODE_REGEX.test(v)) return true;
  if (v.split(".").length === 3) return true; // JWT
  return false;
}

export function isPlaceholderTicketQr(qrCode: string | null | undefined): boolean {
  return typeof qrCode === "string" && PLACEHOLDER_QR_REGEX.test(qrCode.trim());
}

export function resolveTicketQrCode(qrCode: string | null | undefined, ticketId: string): string {
  const normalizedQrCode = qrCode?.trim();

  if (!normalizedQrCode || isPlaceholderTicketQr(normalizedQrCode)) {
    return ticketId;
  }

  return normalizedQrCode;
}